import { Component, OnInit, ChangeDetectorRef, Inject, ViewChild } from '@angular/core';
import { UntypedFormArray, FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { jsonDeepParse, getInvalidFields } from 'src/app/functions/shared-functions';
import { LocationManagerService } from 'src/app/services/shared/location-manager/location-manager.service';
import { markFormGroupTouched } from 'src/app/controls/components/dynamic-form/dynamic-form.component';
import { GoogleMapsPopupComponent } from '../google-maps-popup/google-maps-popup.component';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
declare const google: any;

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
  providers: [LocationManagerService]
})
export class LocationComponent implements OnInit {
  branchList = [];
  active_seller_code;
  countryCodeList = []; //get country code form masters
  status = []; //get country code form masters
  branch_form: UntypedFormGroup = new UntypedFormGroup(
    {
      "id": new UntypedFormControl(null),
      "title": new UntypedFormControl(null, Validators.required),
      "latitude": new UntypedFormControl(null),
      "longitude": new UntypedFormControl(null),
      "status": new UntypedFormControl(1),
      "cityId": new UntypedFormControl(null, Validators.required),
      "cityName": new UntypedFormControl(null, Validators.required),
      "stateId": new UntypedFormControl(null, Validators.required),
      "stateName": new UntypedFormControl(null, Validators.required),
      "addressLine1": new UntypedFormControl(null, Validators.required),
      "addressLine2": new UntypedFormControl(null),
      "countryId": new UntypedFormControl(null),
      "countryName": new UntypedFormControl(null),
      "postalCode": new UntypedFormControl(null),
      jobLocationType: new UntypedFormControl(null),
      attachments: new UntypedFormControl(null),

      // lngId: new FormControl('')

    });
  branch_data_form: UntypedFormGroup;
  latitude;
  longitude;
  geo_decoder = new google.maps.Geocoder;
  loading: boolean = false;
  myFlagForButtonToggle: number = 0;
  masters: any = {}

  selected_address = new Object();
  selected_address_present = new Object();

  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;
  zoom = 18;
  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    zoom: 18,
    scrollwheel: true,
    gestureHandling: "cooperative",
    disableDoubleClickZoom: true,
    mapTypeId: "roadmap",
    mapTypeControl: true,
    streetViewControl: false,
    fullscreenControl: false,
    minZoom: 1,
    maxZoom: 1000,
    zoomControl: true,
  };

  markers = [];
  infoContent;
  marker: MapMarker;
  map_search: UntypedFormControl = new UntypedFormControl(null)
  @ViewChild('addresstext', { static: false }) addresstext: any;
  @ViewChild('addresstextPresent', { static: false }) addresstextPresent: any;

  getPlaceAutocompleteRefPresent = this.getPlaceAutocompletePresent.bind(this);
  process_bar;
  timer;
  google_search;
  pinterval;
  show_map = 1;
  interval;
  manual_save = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public translate: TranslateService,
    private location_srv: LocationManagerService,
    private matDialog: MatDialog,
    private changeDetectRef: ChangeDetectorRef,
    private mat_dialog_ref: MatDialogRef<LocationComponent>,
    private notification: NotificationService
  ) {
  }


  ngOnInit() {

    navigator.permissions
      .query({
        name: "geolocation",
      })
      .then((res) => {

        if (res["state"] == "granted") {
        } else if (res["state"] == "denied") {
          navigator.geolocation.getCurrentPosition((res) => { });
        } else {
          navigator.geolocation.getCurrentPosition((res) => { });
        }
      });

    this.init();
    if (this.data && this.data.id) {
      this.loadMasterWithDetails(this.data.id)
    }
    else {
      if (this.data && this.data.title) {
        this.branch_form.controls.title.patchValue(this.data.title)
      }
      this.loadMasterWithDetails(0)
    }
    if (this.data && this.data.jobLocationType) {
      this.branch_form.controls.jobLocationType.patchValue(this.data.jobLocationType);
    }

    console.log(this.data)
    if (this.data && this.data.manual_save) {
      this.manual_save = this.data.manual_save;
      if (this.data.values) {

        this.branch_form.patchValue(this.data.values)
      }
    }

  }

  loadMasterWithDetails(id) {
    this.location_srv.getBranchDetails({
      id: id
    }).subscribe(res => {
      if (res && res['data']) {
        this.masters = res['data'];
        if (res['data'].detail) {
          res['data'].detail = jsonDeepParse(res['data'].detail)
          this.branch_form.patchValue(res['data'].detail);
        }
      }
    })
  }

  click(event: google.maps.MouseEvent) {
    this.data.latitude = event.latLng.lat();
    this.data.longitude = event.latLng.lng();
    this.latitude = event.latLng.lat();
    this.longitude = event.latLng.lat();

    // console.log(this.data);
    this.addMarker(event.latLng.lat(), event.latLng.lng(), 1);
  }
  addMarker(latitude, longitude, patchValue) {
    // console.log(latitude , longitude);

    this.markers = [];
    this.markers.push({
      position: {
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      },
      label: {
        // color: 'red',
        // text: '.',
      },
      options: {
        icon: "assets/Location_pin_1.png",
        draggable: true,
        animation: window["google"].maps.Animation.DROP,
        // animation: google.maps.Animation.BOUNCE,
      },
      zoom: this.zoom,
    });
    this.center = {
      lat: latitude,
      lng: longitude,
    };
    this.data.latitude = latitude;
    this.data.longitude = longitude;
    this.show_map = 1;
    this.latitude = latitude;
    this.longitude = longitude;
    this.branch_form.controls.latitude.patchValue(this.latitude);
    this.branch_form.controls.longitude.patchValue(this.longitude);

    if (patchValue) {
      this.loadAddressBylatLong()
    }
    // console.log(this.infoContent);
    // console.log(this.marker);


  }

  get controlArray() { return this.branch_data_form.get('formArrayName') as UntypedFormArray; }
  init() {

  }
  loadAddressBylatLong() {
    this.geo_decoder.geocode({ 'location': { lat: this.latitude, lng: this.longitude } }, (results, status) => {
      //   console.log(status);
      if (status === 'OK') {
        let address_components = results[0].address_components;

        try {
          let state;
          let country;
          let pincode;
          let city;
          let addressLine1
          let addressLine2
          address_components.forEach(addr => {
            if (addr['types'][0] == "neighborhood") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_3") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_2") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_1") {
              if (addressLine2) {
                addressLine2 = addressLine2 + ',' + addr['long_name'];
              }
              else {
                addressLine2 = addr['long_name'];

              }
            }
            // else if (addr['types'][0] == "locality") {
            //   if (addressLine2) {
            //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine2 = addr['long_name'];

            //   }
            // }
            else if (addr['types'][0] == "route") {
              if (addressLine2) {
                addressLine2 = addressLine2 + ',' + addr['long_name'];
              }
              else {
                addressLine2 = addr['long_name'];

              }
            }

            else if (addr['types'][0] == 'administrative_area_level_1') {
              state = addr['long_name'];
              if (this.masters && this.masters.stateList && this.masters.stateList.length && state && state != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase().includes(state.toLowerCase()))
                if (i > -1) {
                  state = this.masters.stateList[i].id;
                }
                else {
                  state = 0;
                  this.branch_form.controls.stateName.patchValue(addr['long_name'])
                }
              }
              else {
                state = 0;
                this.branch_form.controls.stateName.patchValue(addr['long_name'])
              }
            }
            else if (addr['types'][0] == 'administrative_area_level_2') {
              city = 0;
              if (this.masters && this.masters.cityList && this.masters.cityList.length && addr['long_name'] && addr['long_name'] != '') {
                let i = this.masters.cityList.findIndex(data => data.title.toLowerCase().includes(addr['long_name'].toLowerCase()))
                if (i > -1) {
                  city = this.masters.cityList[i].id;
                }
                else {
                  city = 0;
                  this.branch_form.controls.cityName.patchValue(addr['long_name'])
                }
              }
              else {
                city = 0;
                this.branch_form.controls.cityName.patchValue(addr['long_name'])
              }
            }
            else if (addr['types'][0] == 'country') {
              country = 0;
              if (this.masters && this.masters.countryList && this.masters.countryList.length && addr['long_name'] && addr['long_name'] != '') {
                let i = this.masters.countryList.findIndex(data => data.title.toLowerCase() == (addr['long_name'].toLowerCase()))
                if (i > -1) {
                  country = this.masters.countryList[i].id;
                }
                else {
                  country = 0;
                  this.branch_form.controls.countryName.patchValue(addr['long_name'])

                }
              }
              else {
                country = 0;
                this.branch_form.controls.countryName.patchValue(addr['long_name'])
              }
            }
            else if (addr['types'][0] == 'postal_code') {
              pincode = addr['long_name'];
            }


          });
          this.branch_form.patchValue({
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            cityId: city,
            postalCode: pincode,
            stateId: state,
            countryId: country,
          })
          this.branch_form.controls.latitude.patchValue(this.latitude);
          this.branch_form.controls.longitude.patchValue(this.longitude);
          this.changeDetectRef.detectChanges()
        }
        catch (err) {
          console.log(err)
        }

        this.changeDetectRef.detectChanges();
        // this.getAddress();
        this.markFormGroupAsUnTouched(this.branch_form);
      } else {
        // window.alert('Geocoder failed due to: ' + status);
      }
    });
  }


  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 15;
      });
    }
  }
  getAddress() {
    this.geo_decoder.geocode({ 'location': { lat: this.latitude, lng: this.longitude } }, (results, status) => {
      if (status === 'OK') {
        let address_components = results[0].address_components
        try {
          let state;
          let country;
          let pincode;
          let city;
          let addressLine1
          let addressLine2
          address_components.forEach(addr => {
            if (addr['types'][0] == "neighborhood") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_3") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_2") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_1") {
              if (addressLine2) {
                addressLine2 = addressLine2 + ',' + addr['long_name'];
              }
              else {
                addressLine2 = addr['long_name'];

              }
            }
            // else if (addr['types'][0] == "locality") {
            //   if (addressLine2) {
            //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine2 = addr['long_name'];

            //   }
            // }
            else if (addr['types'][0] == "route") {
              if (addressLine2) {
                addressLine2 = addressLine2 + ',' + addr['long_name'];
              }
              else {
                addressLine2 = addr['long_name'];

              }
            }

            else if (addr['types'][0] == 'administrative_area_level_1') {
              state = addr['long_name'];
              if (this.masters && this.masters.stateList && this.masters.stateList.length && state && state != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase() == state.toLowerCase())
                if (i > -1) {
                  state = this.masters.stateList[i].id;
                }
                else {
                  state = 0;
                }
              }
              else {
                state = 0;
              }
            }
            else if (addr['types'][0] == 'administrative_area_level_2') {
              city = 0;
              if (this.masters && this.masters.stateList && this.masters.stateList.length && addr['long_name'] && addr['long_name'] != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase() == addr['long_name'].toLowerCase())
                if (i > -1) {
                  city = this.masters.stateList[i].id;
                }
                else {
                  city = 0;
                }
              }
              else {
                city = 0;
              }
            }
            else if (addr['types'][0] == 'country') {
              country = 0;
              if (this.masters && this.masters.stateList && this.masters.stateList.length && addr['long_name'] && addr['long_name'] != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase() == addr['long_name'].toLowerCase())
                if (i > -1) {
                  country = this.masters.stateList[i].id;
                }
                else {
                  country = 0;
                }
              }
              else {
                country = 0;
              }
            }
            else if (addr['types'][0] == 'postal_code') {
              pincode = addr['long_name'];
            }


          });
          this.branch_form.patchValue({
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            cityId: city,
            postalCode: pincode,
            stateId: state,
            countryId: country,
          })
        }
        catch (err) {
          console.log(err)
        }

        // let len = results[0].address_components.length - 1;
        // let pincode = results[0].address_components[len].long_name;
        // let country = results[0].address_components[(len - 1)].long_name
        // let state = results[0].address_components[(len - 2)].long_name;
        // let city = results[0].address_components[(len - 3)].long_name
        // let complete_address = results[0].formatted_address;
        // this.branch_form.patchValue({
        //   addressLine1: complete_address,
        //   city: city,
        //   postalCode: pincode,
        //   state: state,
        //   country: country,
        // })
      }
      else {
        //  window.alert('Geocoder failed due to: ' + status);
      }
    });

  }
  findLocation() {
    this.markFormGroupAsUnTouched(this.branch_form);
    let ref = this.matDialog.open(GoogleMapsPopupComponent, {
      width: '70%',
      data: {
        latitude: this.latitude,
        longitude: this.longitude
      },
      panelClass: 'icr-dialog'

    });
    ref.afterClosed().subscribe(resData => {
      if (resData && this.branch_form && this.branch_form.value && this.branch_form.value.addressLine1) {
        let ref = this.matDialog.open(ConfirmationComponent, {
          width: "35%",
          data: { flag: 6 }, // confirmation for loaction update
          panelClass: 'icr-dialog'
        });
        ref.afterClosed().subscribe(res => {

          if (res == 1) {
            if (resData && resData.latitude && resData.latitude != undefined && resData.longitude != undefined) {
              this.latitude = resData.latitude;
              this.longitude = resData.longitude;
            }
            else {
              if (this.data.branch) {
                this.latitude = this.data.branch.latitude;
                this.longitude = this.data.branch.longitude;
              }
            }
            if (resData && this.latitude && this.longitude) {
              this.geo_decoder.geocode({ 'location': { lat: this.latitude, lng: this.longitude } }, (results, status) => {
                //   console.log(status);
                if (status === 'OK') {
                  let address = results[0].formatted_address;

                  let len = results[0].address_components.length - 1;
                  let pincode = results[0].address_components[len].long_name;
                  let country = results[0].address_components[(len - 1)].long_name
                  let state = results[0].address_components[(len - 2)].long_name;
                  let city = results[0].address_components[(len - 3)].long_name
                  let complete_address = results[0].formatted_address;
                  let countryCode = results[0].address_components[(len - 1)].short_name

                  this.branch_form.controls['countryCode'].patchValue(countryCode);
                  this.branch_form.controls['addressLine1'].patchValue(address);
                  this.changeDetectRef.detectChanges();
                  this.getAddress();
                  this.markFormGroupAsUnTouched(this.branch_form);
                } else {
                  // window.alert('Geocoder failed due to: ' + status);
                }
              });
            }
          }
        })
        return;
      }
      if (resData && (this.branch_form && this.branch_form.value && !this.branch_form.value.addressLine1)) {
        if (resData && resData.latitude && resData.latitude != undefined && resData.longitude != undefined) {
          this.latitude = resData.latitude;
          this.longitude = resData.longitude;
        }
        else {
          if (this.data.branch) {
            this.latitude = this.data.branch.latitude;
            this.longitude = this.data.branch.longitude;
          }
        }
        if (resData && this.latitude && this.longitude) {
          this.geo_decoder.geocode({ 'location': { lat: this.latitude, lng: this.longitude } }, (results, status) => {
            //   console.log(status);
            if (status === 'OK') {
              let address = results[0].formatted_address;
              this.branch_form.controls['addressLine1'].patchValue(address);
              this.changeDetectRef.detectChanges();
              this.getAddress();
              this.markFormGroupAsUnTouched(this.branch_form);

            } else {
              // window.alert('Geocoder failed due to: ' + status);
            }
          });
        }
      }


    })
  }


  close() {
    this.mat_dialog_ref.close();
  }


  markFormGroupTouched(formGroup: UntypedFormGroup) {
    //  console.log(formGroup.controls);

    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.markAsDirty();
      //console.log(control);

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });

  }
  markFormGroupAsUnTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsUntouched();

      //console.log(control);

      if (control.controls) {
        this.markFormGroupAsUnTouched(control);
      }
    });
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
    this.scrollTo(firstElementWithError);
  }
  private getPlaceAutocompletePresent() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstextPresent.nativeElement,
      {
      });
    types: ['address']  // 'establishment' / 'address' / 'geocode'
    // google.maps.event.addListener()
    google.maps.event.addListener(autocomplete, "place_changed", (res) => {
      const address = String(autocomplete.getPlace().formatted_address);
      if (autocomplete.getPlace().geometry && autocomplete.getPlace().geometry.location) {
        this.latitude = autocomplete.getPlace().geometry.location.lat()
        this.longitude = autocomplete.getPlace().geometry.location.lng()
        this.addMarker(this.latitude, this.longitude, 1)
      }
      this.branch_form.controls.addressLine1.setValue(address)
      console.log(address)
      if (autocomplete.getPlace().geometry) {
        let address_components = autocomplete.getPlace().address_components;
        try {
          let state;
          let country;
          let pincode;
          let city;
          let addressLine1
          let addressLine2
          address_components.forEach(addr => {
            if (addr['types'][0] == "neighborhood") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_3") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_2") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_1") {
              if (addressLine2) {
                addressLine2 = addressLine2 + ',' + addr['long_name'];
              }
              else {
                addressLine2 = addr['long_name'];

              }
            }
            // else if (addr['types'][0] == "locality") {
            //   if (addressLine2) {
            //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine2 = addr['long_name'];

            //   }
            // }
            else if (addr['types'][0] == "route") {
              if (addressLine2) {
                addressLine2 = addressLine2 + ',' + addr['long_name'];
              }
              else {
                addressLine2 = addr['long_name'];

              }
            }

            else if (addr['types'][0] == 'administrative_area_level_1') {
              state = addr['long_name'];
              if (this.masters && this.masters.stateList && this.masters.stateList.length && state && state != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase() == state.toLowerCase())
                if (i > -1) {
                  state = this.masters.stateList[i].id;
                }
                else {
                  state = 0;
                }
              }
              else {
                state = 0;
              }
            }
            else if (addr['types'][0] == 'administrative_area_level_2') {
              city = 0;
              if (this.masters && this.masters.stateList && this.masters.stateList.length && addr['long_name'] && addr['long_name'] != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase() == addr['long_name'].toLowerCase())
                if (i > -1) {
                  city = this.masters.stateList[i].id;
                }
                else {
                  city = 0;
                }
              }
              else {
                city = 0;
              }
            }
            else if (addr['types'][0] == 'country') {
              country = 0;
              if (this.masters && this.masters.stateList && this.masters.stateList.length && addr['long_name'] && addr['long_name'] != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase() == addr['long_name'].toLowerCase())
                if (i > -1) {
                  country = this.masters.stateList[i].id;
                }
                else {
                  country = 0;
                }
              }
              else {
                country = 0;
              }
            }
            else if (addr['types'][0] == 'postal_code') {
              pincode = addr['long_name'];
            }


          });
          this.branch_form.patchValue({
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            cityId: city,
            postalCode: pincode,
            stateId: state,
            countryId: country,
          })
        }
        catch (err) {
          console.log(err)
        }
        this.selected_address_present['prefLocation'] = address;
        this.selected_address_present['presentLocation'] = address;
        this.selected_address_present['latitude'] = autocomplete.getPlace().geometry.location.lat();
        this.selected_address_present['longitude'] = autocomplete.getPlace().geometry.location.lng();
        if (this.selected_address_present['latitude']) {
          this.selected_address_present = {};

        }
        this.selected_address_present['countryCode'] = autocomplete.getPlace().address_components[(autocomplete.getPlace().address_components.length - 2)].short_name


      }
      else {
        this.getPlaceByAddressPresent();
      }

    });
  }
  getPlaceByAddressPresent() {
    this.timer = 10;
    const service = new google.maps.places.PlacesService(this.addresstextPresent.nativeElement).findPlaceFromQuery({
      query: this.branch_form.value.addressLine1,
      fields: ['name', 'geometry', 'formatted_address'],
    }, res => {
      // 
      this.pauseTimer();
      this.process_bar = 0;
      if (res && res[0]) {
        let address_components = res[0].address_components;
        try {
          let state;
          let country;
          let pincode;
          let city;
          let addressLine1
          let addressLine2
          address_components.forEach(addr => {
            if (addr['types'][0] == "neighborhood") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_3") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_2") {
              if (addressLine1) {
                addressLine1 = addressLine1 + ',' + addr['long_name'];
              }
              else {
                addressLine1 = addr['long_name'];

              }
            }
            else if (addr['types'][0] == "sublocality_level_1") {
              if (addressLine2) {
                addressLine2 = addressLine2 + ',' + addr['long_name'];
              }
              else {
                addressLine2 = addr['long_name'];

              }
            }
            // else if (addr['types'][0] == "locality") {
            //   if (addressLine2) {
            //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine2 = addr['long_name'];

            //   }
            // }
            else if (addr['types'][0] == "route") {
              if (addressLine2) {
                addressLine2 = addressLine2 + ',' + addr['long_name'];
              }
              else {
                addressLine2 = addr['long_name'];

              }
            }

            else if (addr['types'][0] == 'administrative_area_level_1') {
              state = addr['long_name'];
              if (this.masters && this.masters.stateList && this.masters.stateList.length && state && state != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase() == state.toLowerCase())
                if (i > -1) {
                  state = this.masters.stateList[i].id;
                }
                else {
                  state = 0;
                }
              }
              else {
                state = 0;
              }
            }
            else if (addr['types'][0] == 'administrative_area_level_2') {
              city = 0;
              if (this.masters && this.masters.stateList && this.masters.stateList.length && addr['long_name'] && addr['long_name'] != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase() == addr['long_name'].toLowerCase())
                if (i > -1) {
                  city = this.masters.stateList[i].id;
                }
                else {
                  city = 0;
                }
              }
              else {
                city = 0;
              }
            }
            else if (addr['types'][0] == 'country') {
              country = 0;
              if (this.masters && this.masters.stateList && this.masters.stateList.length && addr['long_name'] && addr['long_name'] != '') {
                let i = this.masters.stateList.findIndex(data => data.title.toLowerCase() == addr['long_name'].toLowerCase())
                if (i > -1) {
                  country = this.masters.stateList[i].id;
                }
                else {
                  country = 0;
                }
              }
              else {
                country = 0;
              }
            }
            else if (addr['types'][0] == 'postal_code') {
              pincode = addr['long_name'];
            }


          });
          this.branch_form.patchValue({
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            cityId: city,
            postalCode: pincode,
            stateId: state,
            countryId: country,
          })
        }
        catch (err) {
          console.log(err)
        }
      }
      else {
      }
    });
    // let timer = setTimeout(()=>{
    //   this.process_bar +=5;
    // },1000);
  }

  submitLocation() {
    if (this.manual_save) {
      this.branch_form.controls.title.clearValidators();
      this.branch_form.controls.title.updateValueAndValidity();
    }
    if (this.branch_form.valid) {
      if (!this.manual_save) {
        this.location_srv.saveBranchDetails(this.branch_form.value).subscribe(res => {
          if (res) {
            console.log(res)
            if (res && res['data'] && res['status']) {
              if (typeof res['data'].id == "string") {
                res['data'].id = parseInt(res['data'].id)
              }
              this.branch_form.controls.id.patchValue(res['data'].id);
              this.mat_dialog_ref.close(this.branch_form.value);
            }
          }
        })
      }
      else {
        this.mat_dialog_ref.close(this.branch_form.value);
      }

    }
    else {
      getInvalidFields(this.branch_form, this.translate, this.notification, 'LOCATION.')
      markFormGroupTouched(this.branch_form);

    }

  }
  newLocation() {
    this.branch_form.reset();
    if (this.data.jobLocationType) {
      this.branch_form.controls.jobLocationType.patchValue(this.data.jobLocationType)
    }
  }

  setTimer() {
    this.show_map = 0;
    if (this.show_map != 1) {
      this.startTimer();
    }
    if (this.interval) {
      clearTimeout(this.interval);
    }
    this.interval = setTimeout(() => {
    }, 3000);
  }
  startTimer() {
    this.pinterval = setInterval(() => {
      if (this.process_bar < 90) {
        this.process_bar += 1;
      } else {
        this.process_bar = 0;
      }
    }, 1000)
  }
  pauseTimer() {
    clearInterval(this.pinterval);
  }

  cityChanged(ev) {
    console.log(ev)
    console.log(this.branch_form.value)
  }


}
